import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { Quiz } from './pages/Quiz';
import { OptIn } from './pages/OptIn';
import { Off1 } from './pages/Off1';
import { Off2 } from './pages/Off2';
export function AppRouter() {
  return <BrowserRouter data-id="element-38">
      <Routes data-id="element-39">
        <Route path="/" element={<App data-id="element-41" />} data-id="element-40" />
        <Route path="/quiz" element={<Quiz data-id="element-43" />} data-id="element-42" />
        <Route path="/opt-in" element={<OptIn data-id="element-45" />} data-id="element-44" />
        <Route path="/off1" element={<Off1 data-id="element-47" />} data-id="element-46" />
        <Route path="/off2" element={<Off2 data-id="element-49" />} data-id="element-48" />
      </Routes>
    </BrowserRouter>;
}